<template>
    <div class="verified-input">
        <VerifiedLable
            :id="id"
            :title="title"
            :tagnewid="tagnewid"
            :required="required"
            :disableMLtitle="disableMLtitle"
            :tooltipLabel="tooltipLabel"
            :tooltipPosition="tooltipPosition"
            :tooltipType="tooltipType"
            :tooltipSize="tooltipSize"
            :tooltipMultilined="tooltipMultilined"
        />

        <vue-timepicker
            class="full-width vue-time-picker"
            :class="{
                invalid: focusedOut && invalid && innerInvalidWhenDisabled,
                smaller: smaller,
            }"
            close-on-complete
            manual-input
            :hide-clear-button="hideClearButton"
            :value="value"
            @input="$emit('input', $event)"
            :disabled="disabled"
            :required="required"
            @focus="focusEvt()"
            @keyup="onKeyUp()"
            @blur="blurEvt()"
        />

        <span
            class="validation"
            v-text="getTranslation(msg, '')"
            v-if="focusedOut && invalid && innerInvalidWhenDisabled"
        />
        <div class="clearfix" v-else-if="innerInvalidWhenDisabled && !noClearfix" />
    </div>
</template>

<script>
import VerifiedLable from '@/components/shared/VerifiedLable.vue';

export default {
    name: 'VerifiedTimePicker',
    components: {
        VerifiedLable,
    },
    props: {
        value: {
            default: null,
        },
        id: {
            default: null,
        },
        placeholder: {
            default: '',
            type: String,
        },
        title: {
            default: '',
            type: String,
        },
        msg: {
            default: 'msg-campo-obrigatorio',
            type: String,
        },
        invalid: {
            default: false,
            type: [Boolean, Function],
        },
        disabled: {
            default: false,
            type: Boolean,
        },
        invalidWhenDisabled: {
            type: Boolean,
            default: false,
        },
        onBlur: {
            default: true,
            type: Boolean,
        },
        onBlurFunction: {
            default: () => {},
            type: Function,
        },
        onFocus: {
            default: () => {},
            type: Function,
        },
        onKeyUp: {
            default: () => {},
            type: Function,
        },
        smaller: {
            type: Boolean,
            default: false,
        },
        disableMLtitle: {
            type: Boolean,
            default: false,
        },
        disableMLplaceholder: {
            type: Boolean,
            default: false,
        },
        noClearfix: {
            type: Boolean,
            default: false,
        },
        // Id do tagnew referente ao .env na raiz do sistema
        tagnewid: undefined,
        // O título fica com a cor primária da empresa e com um asterisco após o título
        required: {
            type: Boolean,
            default: false,
        },
        /* Caso tenha uma informação adicional sobre o campo */
        tooltipLabel: {
            type: String,
            default: null,
        },
        tooltipPosition: {
            type: String,
            default: 'is-right',
        },
        tooltipType: {
            type: String,
            default: 'is-dark',
        },
        tooltipMultilined: {
            type: Boolean,
            default: true,
        },
        tooltipSize: {
            type: String,
            default: 'is-large',
        },
        hideClearButton: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            innerId: null,
            focusedOut: false,
            innerType: this.type,
            innerInvalidWhenDisabled: false,
        };
    },
    mounted() {
        this.focusedOut = !this.onBlur;
    },
    created() {
        this.innerId =
            this.id == null
                ? new Date().getTime() + '' + Math.floor(Math.random() * 10000)
                : this.id;

        this.innerInvalidWhenDisabled =
            !this.disabled || (this.invalidWhenDisabled && this.disabled);
    },
    methods: {
        focusEvt() {
            this.focusedOut = false;

            if (this.onFocus) {
                this.onFocus();
            }
        },
        blurEvt() {
            this.focusedOut = true;

            if (this.onBlur) {
                this.onBlurFunction();
            }
            // para quando quiser apenas saber se foi executado o blur
            this.$emit('onBlurFunction');
        },
    },
};
</script>

<style lang="scss" scoped>
span.validation {
    font-size: 8px;
    color: $red;
    display: block;
    font-weight: 600;
}
.vue-time-picker.invalid input {
    border: 1px solid $red-alert !important;
}

.v-input.smaller {
    height: 24px;
    font-size: 12px;
}
.clearfix {
    height: 12px;
}
</style>
<style lang="scss">
.vue-time-picker.invalid > input {
    border: 1px solid $red-alert !important;
}
</style>
